<template>
  <div class="venue-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="800"
            :mask-closable="false"
            :styles="styles">
      <Form :model="dataInfo"
            label-position="top"
            ref="dataInfoValidate"
            action="javascript:void(0)">
        <FormItem label="选择园区">
          <Select v-model="dataInfo.smarkpark_id"
                  filterable
                  clearable>
            <Option v-for="item in smarkparkList"
                    :value="item.id"
                    :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称">
          <Input v-model="dataInfo.title"
                 placeholder="请输入标题" />
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea"
                 v-model="dataInfo.descript"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="散客温馨提示">
          <Input type="textarea"
                 v-model="dataInfo.notice"
                 :rows="3"
                 placeholder="请输入温馨提示" />
        </FormItem>
        <FormItem label="团体温馨提示">
          <Input type="textarea"
                 v-model="dataInfo.team_notice"
                 :rows="3"
                 placeholder="请输入温馨提示" />
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb v-model="dataInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*385,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="内容">
          <!--          <editor-bar v-model="dataInfo.content" :isClear="isClear" ref="editContent"></editor-bar>-->
          <UEditor v-model="dataInfo.content"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="散客购票须知">
          <!--          <editor-bar v-model="dataInfo.notice_user" :isClear="isClear" ref="editContent1"></editor-bar>-->
          <UEditor v-model="dataInfo.notice_user"
                   ref="editContent1"></UEditor>
        </FormItem>
        <FormItem label="团队购票须知">
          <!--          <editor-bar v-model="dataInfo.notice_team" :isClear="isClear" ref="editContent2"></editor-bar>-->
          <UEditor v-model="dataInfo.notice_team"
                   ref="editContent2"></UEditor>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="dataInfo.sort"
                 placeholder="排序"></Input>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="createpushtype('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";

export default {
  name: "venue-list",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      loading: true,
      dataloading: true,
      formItem: {},
      thumblist: [],
      smarkparkList: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns: [
        {
          title: "排序",
          width: 90,
          key: "sort",
          render: (h, params) => {
            return h("div", [
              h(
                "Input",
                {
                  props: {
                    value: params.row.sort
                  },
                  on: {
                    "on-enter": value => {
                      this.editSort(params.row.id, value.target.value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: "Id",
          key: "id",
          width: 100
        },
        {
          title: "标题",
          key: "title"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.ticket(params.row.id);
                    }
                  }
                },
                "门票"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        title: "",
        describe: "",
        content: "",
        notice: "",
        team_notice: "",
        sort: "0"
      },
      showModalStatus: false,
      editor: {},
      dataInfoValidate: {}
    };
  },
  // 计算
  computed: {},
  components: {
    UploadThumb,
    UEditor
  },
  // 监听
  watch: {},
  created: function () {
    this.$api.smartpark
      .list({
        page: 1,
        size: 100
      })
      .then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.smarkparkList = res.result.list;
        }
      });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var self = this;
      this.$api.smartvenue
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            self.tablelist = res.result.list;
            self.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 修改排序
    editSort: function (index, value) {
      this.$api.smartvenue.sort({ id: index, sort: value }).then(res => {
        if (res.code == 200) {
          this.getTableList();
        }
      });
    },
    ticket (id) {
      this.$router.push("/smartticket/list/" + id);
    },
    // 展开添加
    showModel () {
      this.dataInfoid = 0;
      this.dataInfo = {
        title: "",
        describe: "",
        content: "",
        notice: "",
        team_notice: "",
        sort: "0"
      };
      this.thumblist = new Array();
      // this.$refs["editContent"].editor.txt.html("");
      // this.$refs["editContent1"].editor.txt.html("");
      // this.$refs["editContent2"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.$refs["editContent1"].message = "";
      this.$refs["editContent2"].message = "";
      this.$refs["dataInfoValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    detail: function (index) {
      this.dataInfoid = index;
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.smartvenue.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.result;
          // this.$refs["editContent"].editor.txt.html(this.dataInfo.content);
          // this.$refs["editContent1"].editor.txt.html(this.dataInfo.notice_user);
          // this.$refs["editContent2"].editor.txt.html(this.dataInfo.notice_team);
          this.$refs["editContent"].message = this.dataInfo.content;
          this.$refs["editContent1"].message = this.dataInfo.notice_user;
          this.$refs["editContent2"].message = this.dataInfo.notice_team;
          if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
            this.thumblist.push({
              name: this.dataInfo.thumb,
              url: this.dataInfo.thumb,
              status: "finished"
            });
          }
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype (name) {
      // 视频 和 图文 有封面图
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.dataInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.dataInfo.thumb = null;
      }
      this.dataInfo.content = this.$refs["editContent"].message;
      this.dataInfo.notice_user = this.$refs["editContent1"].message;
      this.dataInfo.notice_team = this.$refs["editContent2"].message;
      if (
        this.dataInfoid == null ||
        this.dataInfoid == 0 ||
        this.dataInfoid == undefined
      ) {
        this.$api.smartvenue.create(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.dataInfo.id = this.dataInfoid;
        this.$api.smartvenue.edit(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      // console.log(ps);
      this.$api.smartvenue.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartvenue.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-form .ivu-form-item-label {
}
</style>